module.exports = "/images/smarty-says-mr.png?daa054b3bace188ae2a43efd621e2f16";